import React, { useRef, useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import {
  Row, Col, Container, Media, TabContent,
  TabPane, Nav,
  NavItem,
  NavLink,
  Button
} from "reactstrap";
import axios from 'axios';
import swal from 'sweetalert';
import { useHistory } from 'react-router';
import MasterSocial from "../../../../product-details/common/master_social";
import ImageZoom from "../../../../product-details/common/image-zoom";
import Service from "../../../../product-details/common/service";
import CommonLayout from "../../../../../components/shop/common-layout";
import Slider from "react-slick";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import { useTranslation } from "react-i18next";
import { urlApi } from "../../../../../config";


const DetailProduct = (props) => {
  const [state, setState] = useState({ nav1: null, nav2: null });
  const slider1 = useRef();
  const slider2 = useRef();
  const [loading, setLoading] = useState(true);
  const [product, setProduct] = useState([]);
  const history = useHistory();
  const [activeTab, setActiveTab] = useState("1");
  const [t, i18n] = useTranslation("global");
  var products = {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    fade: true,
  };
  var productsnav = {
    slidesToShow: 3,
    swipeToSlide: true,
    arrows: false,
    dots: false,
    focusOnSelect: true,
  };
  const { nav1, nav2 } = state;
  useEffect(() => {
    setState({
      nav1: slider1.current,
      nav2: slider2.current,
    });
    let isMounted = true;
    const category_slug = props.match.params.category;
    const product_slug = props.match.params.product;

    axios.get(`/api/viewproductdetail/${category_slug}/${product_slug}`).then(res => {
      if (isMounted) {

        if (res.data.status === 200) {
          setProduct(res.data.product);
          setLoading(false);

        } else if (res.data.status === 400) {

          swal("Error", res.data.message, "");

        }
        else if (res.data.status === 404) {

          history.push('/collections');
          swal("Alerta", res.data.message, "error");

        }
      }
    });
    return () => {
      isMounted = false;
    }
  }, [props.match.params.category, props.match.params.product, history]);

  if (loading) {

    return <Container className="col-md-2">
      <Row><h4 className="button-center h4-search">{t("view-category.category10")}</h4>
      </Row>
    </Container>

  } else {

  }
  return (
    <CommonLayout parent={product.subcategory.name} title={t("view-category.category9")}>
      <>
        <div className="collection-wrapper">
          <Container>
            <Row>
              <Col lg="9" sm="12" xs="12">
                <div className="container-fluid">
                  <Row>
                    <Col xl="12">
                    </Col>
                  </Row>

                  <Row>
                    <Col lg="6" className="product-thumbnail">
                      <Carousel >
                        <div className="image">

                          <img src={`https://lordon.com.mx:81/${product.image1}`} className="image-fluid" style={{ maxWidth: '30rem' }} alt={product.name_product} />
                        </div>

                        <div className="image">
                          <img src={`https://lordon.com.mx:81/${product.image2}`} className="image-fluid" style={{ maxWidth: '30rem' }} alt={product.name_product} />
                        </div>

                        {/* <div className="image">
                          <img src={`https://lordon.com.mx:81/${product.image3}`} className="image-fluid" style={{ maxWidth: '30rem' }} alt={product.name_product} />
                        </div>

                        <div className="image">
                          <img src={`https://lordon.com.mx:81/${product.image4}`} className="image-fluid" style={{ maxWidth: '30rem' }} alt={product.name_product} />

                        </div> */}

                      </Carousel>
                    </Col>
                    <Col lg="6" className="rtl-text">
                      <div className={`product-right`}>
                        <h3 class="text-blue box-p2 "> {product.name_product} </h3>
                        {/* 
                        <h4>
                          <del>
                            {product.discount_price}


                          </del>
                        </h4>
                        <h2>
                          {product.price_product}
                        </h2> */}



                        <div className="border-product">
                          <h3>{t("business.business12")}</h3>
                          <h4 className="h4-search">{product.meta_description}</h4>
                        </div>

                        <div className="border-product">
                          <Link to='/contact/'>
                            <Button className="btn btn-solid text-center" type="submit"
                            >
                              {t("business.business11")} 
                            </Button>
                          </Link>
                        </div>

                      </div>
                    </Col>
                  </Row>

                </div>
                <section className="tab-product m-0">
                  <Container>
                    <Row>
                      <Col sm="12" lg="12">
                        <Row className="product-page-main m-0">
                          <Nav tabs className="nav-material">
                            <NavItem className="nav nav-tabs" id="myTab" role="tablist">
                              <NavLink
                                className={activeTab === "1" ? "active" : ""}
                                onClick={() => setActiveTab("1")}
                              >
                                {t("business.business13")} 
                              </NavLink>
                            </NavItem>

                          </Nav>

                          <span style={{textAlign: 'center'}}> {product.description_product}</span>
                          {/* <TabContent activeTab={activeTab} className="nav-material">
                            <TabPane tabId="1">
                              <br></br>
                                  

                            </TabPane>

                          </TabContent> */}
                          <br></br>
                          <br></br>
                        </Row>
                      </Col>
                    </Row>
                  </Container>
                </section>

              </Col>

              <Col sm="3" className="collection-filter">
                <Service />

              </Col>
            </Row>
          </Container>
        </div>

      </>
    </CommonLayout>


  );
};

export default DetailProduct;